export default "__VITE_ASSET__CwvM5iR6__"